import { render, staticRenderFns } from "./infoCheck.vue?vue&type=template&id=3ff020f4&scoped=true"
import script from "./infoCheck.vue?vue&type=script&lang=js"
export * from "./infoCheck.vue?vue&type=script&lang=js"
import style0 from "./infoCheck.vue?vue&type=style&index=0&id=3ff020f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff020f4",
  null
  
)

export default component.exports